// 取込CSVの対象期間の月ズレ検知（本城さんの質問 2026-09-01）
//
// 取込はキャリアごとに1枚ずつ保持する（ADD_IMPORT はそのキャリアの枠だけを差し替える）。
// そのため「8月分を作るときにヤマトだけ差し替えて、佐川に7月分が残る」と、
// 前月と当月が混ざった明細が無警告で出来上がる。混ざったまま確定・発行されると
// 支払金額そのものが狂うため、フラグではなく実データ（CSVの対象期間）で検知する。

export type PeriodLike = { periodStart: string | null } | null | undefined;

export type PeriodMismatch = {
  yamatoMonth: string; // YYYY-MM
  sagawaMonth: string; // YYYY-MM
};

/** "2026-07-01" → "2026-07"。取れないときは null */
export function monthOf(meta: PeriodLike): string | null {
  const s = meta?.periodStart;
  if (!s || s.length < 7) return null;
  return s.substring(0, 7);
}

/**
 * ヤマトと佐川の対象期間が別の月になっていたら、その2つの月を返す。
 * 片方しか取り込んでいない・期間が判定できない場合は null（＝警告しない）。
 */
export function detectPeriodMismatch(yamato: PeriodLike, sagawa: PeriodLike): PeriodMismatch | null {
  const y = monthOf(yamato);
  const s = monthOf(sagawa);
  if (!y || !s || y === s) return null;
  return { yamatoMonth: y, sagawaMonth: s };
}

/** 画面・確認ダイアログで共通に使う説明文 */
export function periodMismatchMessage(m: PeriodMismatch): string {
  return (
    `取込中のCSVの対象月が揃っていません（ヤマト ${formatMonthLabel(m.yamatoMonth)} ／ 佐川 ${formatMonthLabel(m.sagawaMonth)}）。` +
    `このままだと2か月分が混ざった金額になります。CSV取込画面で前月分を「削除」してから、当月分をアップロードしてください。`
  );
}

/** "2026-07" → "2026年7月" */
export function formatMonthLabel(month: string): string {
  const [y, m] = month.split("-");
  return y && m ? `${y}年${Number(m)}月` : month;
}
